'use client';
import { useRequest } from 'ahooks';
import { getPageConfig } from '@/app/apis';

/**
 *
 * @param configKeys
 * @returns
 */
export const usePageConfigs = (configKeys: string[]) => {
  const { loading, data, run } = useRequest(
    () => {
      return getPageConfig({
        query: {
          keys: configKeys,
        },
      });
    },
    {
      manual: true,
    },
  );

  return {
    configLoading: loading,
    configData: data?.error ? undefined : (data?.data?.values as Record<string, string>),
    getPageConfigs: run,
  };
};

export enum PAGE_CONFIG_KEY {
  templateEntranceLabel = 'template_entrance_tag',
}
